/**
 * Created by zqy on 2018/10/24 0024.
 */
const config = {
  development: {//开发环境
    api: "http://127.0.0.1:18086/",//接口api地址
    uploadFileApi:'jbt/generate/upload/uploadFile',//文件上传接口路由地址
    uploadImageApi:'jbt/generate/upload/imageUpload',//单图上传接口路由地址
    webURL: '/',//H5地址
    imgPath: 'http://test.lamiertech.cn/img/',//图片服务器地址
    successCode:0,//数据交互返回成功对应码
    requestFormData:true,//api请求参数是否使用Form Data
    // api: 'http://nm.admin.cdwsx.cn/',//接口api地址
    // uploadFileApi:'jbt/generate/upload/uploadFile',//文件上传接口路由地址
    // uploadImageApi:'jbt/generate/upload/imageUpload',//单图上传接口路由地址
    // webURL: '/admin',//H5访问地址
    // imgPath: 'http://nm.admin.cdwsx.cn/img/',//图片服务器地址
    // successCode:0,//数据交互返回成功对应码
    // requestFormData:true,//api请求参数是否使用Form Data
  },
  production: {//生产环境
    api: "http://test.lamiertech.cn/",//接口api地址
    uploadFileApi:'jbt/generate/upload/uploadFile',//文件上传接口路由地址
    uploadImageApi:'jbt/generate/upload/imageUpload',//单图上传接口路由地址
    webURL: '/',//H5地址
    imgPath: 'http://test.lamiertech.cn/img/',//图片服务器地址
    successCode:0,//数据交互返回成功对应码
    requestFormData:true,//api请求参数是否使用Form Data
  },
  testing: {//测试环境
    api: 'http://nm.admin.cdwsx.cn/',//接口api地址
    uploadFileApi:'jbt/generate/upload/uploadFile',//文件上传接口路由地址
    uploadImageApi:'jbt/generate/upload/imageUpload',//单图上传接口路由地址
    webURL: '/admin',//H5访问地址
    imgPath: 'http://nm.admin.cdwsx.cn/img/',//图片服务器地址
    successCode:0,//数据交互返回成功对应码
    requestFormData:true,//api请求参数是否使用Form Data
  },
}
// export default config[process.env['NODE_ENV']]

let baseConfig=config[process.env['NODE_ENV']]
if (process.env.NODE_ENV === 'production' && process.env.type === 'testing') {
  // 测试环境
  baseConfig = config.testing
}
export default baseConfig



// WEBPACK FOOTER //
// ./src/config/index.js